import type { Options as IconOptions } from 'ol/style/Icon'
import { Icon, Style } from 'ol/style'

import vehiclesSpriteSheet from '@/resources/map-markers/devicesAndVehicles.png'

import { genericStyles } from '../../genericStyles'

const vehicleCircleStylesCache: Map<string, Style> = new Map()

export const getVehicleCircleFeatureStyle = (
  marker: uui.domain.ui.map.markers.Vehicle,
  mode: uui.domain.ui.map.markers.MapStyles['vehicle']['mode'],
) => {
  if (mode === 'off') return genericStyles.hidden

  const coordinates = marker.circleGrid

  const spriteSheetUrl = vehiclesSpriteSheet
  const cellSize = coordinates[2]
  const x = coordinates[0]
  const y = coordinates[1]

  const cacheId = `${x}_${y}`

  if (vehicleCircleStylesCache.has(cacheId)) {
    const cachedStyle = vehicleCircleStylesCache.get(cacheId)

    if (cachedStyle) return cachedStyle
  }

  const opts: IconOptions = {
    anchor: [0.5, 0.5],
    anchorOrigin: 'top-left',
    anchorYUnits: 'fraction',
    anchorXUnits: 'fraction',
  }

  const style = new Style({
    image: new Icon({
      src: spriteSheetUrl,
      crossOrigin: 'anonymous',

      scale: 0.5,
      opacity: 1.0,
      rotation: 0.0,
      rotateWithView: true,

      size: [cellSize, cellSize],
      offset: [x, y],

      ...opts,
    }),
  })

  vehicleCircleStylesCache.set(cacheId, style)

  return style
}
